const CONFIGURED_API_BASE =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_BASE_URL) ||
  "https://api.home-helper.com";

function shouldUseLanApi(hostname) {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.")
  );
}

export function getApiBaseUrl() {
  try {
    if (typeof window !== "undefined") {
      if (window.__API_BASE__) {
        return String(window.__API_BASE__).trim().replace(/\/+$/, "");
      }

      const hostname = window.location.hostname || "";
      if (
        (CONFIGURED_API_BASE === "https://api.home-helper.com" || !CONFIGURED_API_BASE) &&
        shouldUseLanApi(hostname)
      ) {
        return `${window.location.protocol}//${hostname}:4000`;
      }
    }
  } catch {
    // ignore window access errors at module load time
  }

  return String(CONFIGURED_API_BASE || "https://api.home-helper.com").trim().replace(/\/+$/, "");
}
